if (!customElements.get("pcard-swatch")) {
  class PcardColorSwatch extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-pcard-variant-picker]",
        optionNodes: [".m-product-option--node__label"],
        featuredImage: ".m-product-card__main-image",
        hoverImage: ".m-product-card__hover-image",
        pcard: ".m-product-card",
        variantDropdown: ".m-product-option--dropdown-select",
        priceWrapper: ".m-price",
        salePrice: ".m-price-item--sale",
        compareAtPrice: [".m-price-item--regular"],
        unitPrice: ".m-price__unit",
        soldOutBadge: ".m-product-tag--soldout",
      };
      this.container = this.closest(this.selectors.container);
      this.pcard = this.closest(this.selectors.pcard);
      this.variantIdNode = this.pcard && this.pcard.querySelector('[name="id"]');
      this.featuredImage = this.pcard && this.pcard.querySelector(this.selectors.featuredImage);
      this.hoverImage = this.pcard && this.pcard.querySelector(this.selectors.hoverImage);
      this.domNodes = queryDomNodes(this.selectors, this.pcard);
      this.setupData();
    }

    async setupData() {
      this.variantData = this.getVariantData();
      this.initOptionSwatches();
      this.productHandle = this.container.dataset.productHandle;
      this.productData = await this.getProductJson();
      this.activeOptionNodeByPosition = {};
      this.hide_unavailable_product_options = MinimogSettings.hide_unavailable_product_options;

      // Get limits from container data attributes
      this.limitDesktop = parseInt(this.container.dataset.limitDesktop) || 99;
      this.limitMobile = parseInt(this.container.dataset.limitMobile) || 99;
      this.productUrl = this.container.dataset.productUrl || '';

      const { variantIdNode, productData, productData: { variants } = {} } = this;

      if (productData) {
        let currentVariantId = variantIdNode && Number(variantIdNode.value);
        if (
  window.location.pathname === "/search" &&
  this.pcard.dataset.productId === "9289333670126"
) {
  const firstAvailableVariant = variants.find((variant) => variant.available);

  if (firstAvailableVariant) {
    currentVariantId = firstAvailableVariant.id;

    if (variantIdNode) {
      variantIdNode.value = currentVariantId;
      variantIdNode.dataset.selectedVariant = currentVariantId;
    }

    this.productData.selected_variant = firstAvailableVariant;
  }
}
        if (!currentVariantId) {
          currentVariantId =
            productData.selected_or_first_available_variant && productData.selected_or_first_available_variant.id;
        }
        const currentVariant = variants.find((v) => v.id === currentVariantId) || variants[0];
        this.productData.initialVariant = currentVariant;
        if (!this.productData.selected_variant && variantIdNode && variantIdNode.dataset.selectedVariant) {
          this.productData.selected_variant = variants.find(
            (v) => v.id === Number(variantIdNode && variantIdNode.dataset.selectedVariant)
          );
        }

        // Build availability map and process swatches
        this.buildAvailabilityMap();
        this.processSwatchAvailability();

        this.updateOptionByVariant(currentVariant);

       window.MinimogEvents.subscribe("m:image-loaded", () => {
  if (!this.currentVariant) {
    this.changeProductImage(currentVariant);
  }
});
      }

      this.domNodes.optionNodes &&
        this.domNodes.optionNodes.forEach((node) =>
          node.addEventListener("click", this.handleSelectVariant.bind(this))
        );
      this.domNodes.variantDropdown &&
        this.domNodes.variantDropdown.addEventListener("change", this.handleSelectVariant.bind(this));

      // Add resize handler for responsive limits
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.debounce(this.handleResize, 150));
    }

    debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    handleResize() {
      const swatchContainers = this.querySelectorAll('[data-total-options]');

      swatchContainers.forEach((container) => {
        const allNodes = Array.from(container.querySelectorAll('[data-swatch-node]'));
        const moreOptionsLink = container.querySelector('[data-more-options]');
        const swatchNodes = allNodes.filter((node) => !node.classList.contains('m-pcard-swatch--filtered-out'));

        if (swatchNodes.length === 0) return;

        let availableCount = 0;
        let unavailableCount = 0;

        swatchNodes.forEach((node) => {
          const isUnavailable = node.classList.contains('m-product-option--node__soldout') ||
            (node.closest('.m-product-option--node__soldout') !== null);
          if (isUnavailable) {
            unavailableCount++;
          } else {
            availableCount++;
          }
        });

        this.updateSwatchVisibility(container, swatchNodes, availableCount, unavailableCount, moreOptionsLink);
      });
    }

    buildAvailabilityMap() {
      // Build a map of option values to their availability
      // For each option position, map value -> hasAvailableVariant
      this.availabilityMap = {};
      const { variants = [] } = this.productData || {};
      
      variants.forEach((variant) => {
        ['option1', 'option2', 'option3'].forEach((optKey, idx) => {
          const optValue = variant[optKey];
          if (optValue) {
            const position = idx + 1;
            const key = `${position}:${optValue}`;
            if (!this.availabilityMap[key]) {
              this.availabilityMap[key] = false;
            }
            if (variant.available) {
              this.availabilityMap[key] = true;
            }
          }
        });
      });
    }

    isOptionAvailable(optionPosition, optionValue) {
      const key = `${optionPosition}:${optionValue}`;
      return this.availabilityMap[key] === true;
    }

    /**
     * Lê filtros de opção ativos na URL no padrão Shopify (filter.v.option.<nome>=valor).
     * Retorna { <nome em minúsculas>: [valores] } — pode ter múltiplos valores por opção.
     */
    getActiveOptionFilters() {
      const filters = {};
      try {
        const params = new URLSearchParams(window.location.search);
        for (const [key, value] of params.entries()) {
          const m = key.match(/^filter\.v\.option\.(.+)$/i);
          if (!m || !value) continue;
          const resolved = this.resolveFilterValue(key, value);
          // Sem valor utilizável, o filtro não deve restringir nada: melhor
          // mostrar todas as cores do que esconder todas.
          if (!resolved) continue;
          const name = m[1].toLowerCase();
          (filters[name] = filters[name] || []).push(resolved);
        }
      } catch (e) {}
      return filters;
    }

    /**
     * Quando o filtro está agrupado no admin, a URL carrega um
     * gid://shopify/FilterSettingGroup/... que não existe nas variantes.
     * O rótulo do grupo (ex.: "34") está no checkbox do filtro na página.
     */
    resolveFilterValue(key, value) {
      const raw = String(value);
      if (raw.indexOf('gid://') !== 0) return raw;
      const inputs = document.querySelectorAll('input[name="' + key + '"]');
      for (const input of inputs) {
        if (input.value !== raw) continue;
        const label = (input.id && document.querySelector('label[for="' + input.id + '"]')) || input.closest('label');
        if (!label) break;
        const text = label.textContent.replace(/\(\s*\d+\s*\)\s*$/, '').trim();
        if (text) return text;
      }
      return null;
    }

    /**
     * O rótulo do grupo é o tamanho puro ("34"), mas a variante guarda
     * "34 BR". Compara valor exato ou o primeiro token.
     */
    filterValueMatches(variantValue, filterValue) {
      const a = String(variantValue == null ? '' : variantValue).trim().toLowerCase();
      const b = String(filterValue == null ? '' : filterValue).trim().toLowerCase();
      if (!a || !b) return false;
      if (a === b) return true;
      return a.split(/\s+/)[0] === b;
    }

    processSwatchAvailability() {
      const swatchContainers = this.querySelectorAll('[data-total-options]');
      const activeFilters = this.getActiveOptionFilters();
      const productOptionNames = ((this.productData && this.productData.options) || []).map((o) =>
        (typeof o === "string" ? o : (o && o.name) || "").toLowerCase()
      );
      const variants = (this.productData && this.productData.variants) || [];

      swatchContainers.forEach((container) => {
        const swatchNodes = container.querySelectorAll('[data-swatch-node]');
        const moreOptionsLink = container.querySelector('[data-more-options]');

        if (swatchNodes.length === 0) return;

        const firstLabel = swatchNodes[0].querySelector('[data-option-position]') || swatchNodes[0];
        const optionPosition = Number(firstLabel.dataset.optionPosition);
        const swatchOptionKey = `option${optionPosition}`;
        const swatchOptionName = (productOptionNames[optionPosition - 1] || "").toLowerCase();

        // Apenas filtros de OUTRAS opções restringem quais swatches devem aparecer
        const relevantFilters = {};
        Object.keys(activeFilters).forEach((name) => {
          if (name === swatchOptionName) return;
          const idx = productOptionNames.indexOf(name);
          if (idx === -1) return;
          relevantFilters[`option${idx + 1}`] = activeFilters[name];
        });

        const availableSwatches = [];
        const unavailableSwatches = [];

        swatchNodes.forEach((node) => {
          const label = node.querySelector('[data-option-position]') || node;
          const optValue = label.dataset.value;

          // Variantes desta cor que respeitam os filtros ativos das outras opções
          const matchingVariants = variants.filter((v) => {
            if (v[swatchOptionKey] !== optValue) return false;
            for (const key of Object.keys(relevantFilters)) {
              if (!relevantFilters[key].some((f) => this.filterValueMatches(v[key], f))) return false;
            }
            return true;
          });

          if (matchingVariants.length === 0) {
            // Nenhuma variante dessa cor existe sob os filtros → esconder do card
            node.style.display = 'none';
            node.classList.add('m-pcard-swatch--filtered-out');
            return;
          }
          node.style.display = '';
          node.classList.remove('m-pcard-swatch--filtered-out');

          const isAvailable = matchingVariants.some((v) => v.available);

          if (isAvailable) {
            availableSwatches.push(node);
            node.classList.remove('m-product-option--node__soldout');
          } else {
            unavailableSwatches.push(node);
            node.classList.add('m-product-option--node__soldout');
          }
        });

        const orderedSwatches = [...availableSwatches, ...unavailableSwatches];
        
        // Reorder DOM elements
        orderedSwatches.forEach((node) => {
          container.insertBefore(node, moreOptionsLink);
        });

        // Update visibility based on limits and filter mode
        this.updateSwatchVisibility(container, orderedSwatches, availableSwatches.length, unavailableSwatches.length, moreOptionsLink);
        
        // Mark swatches as ready to show (removes visibility: hidden)
        orderedSwatches.forEach((node) => node.classList.add('m-swatch-ready'));
        if (moreOptionsLink) moreOptionsLink.classList.add('m-swatch-ready');
      });
    }

    updateSwatchVisibility(container, orderedSwatches, availableCount, unavailableCount, moreOptionsLink) {
      const isMobile = window.innerWidth < 768;
      const limit = isMobile ? this.limitMobile : this.limitDesktop;
      
      // First reset all visibility
      orderedSwatches.forEach((node) => {
        node.style.display = '';
        node.classList.remove('m-pcard-swatch--hidden-desktop', 'm-pcard-swatch--hidden-mobile');
      });
      
      let visibleCount = 0;
      
      orderedSwatches.forEach((node) => {
        // Show/hide based on limit
        if (visibleCount < limit) {
          visibleCount++;
        } else {
          // Hide beyond limit
          node.style.display = 'none';
        }
      });

      // Soma TODAS as cores restantes (disponíveis + esgotadas) que não couberam
      // no limite, em vez de só as disponíveis.
      const totalCount = availableCount + unavailableCount;
      const restDesktop = Math.max(0, totalCount - this.limitDesktop);
      const restMobile = Math.max(0, totalCount - this.limitMobile);

      // Update the +X link
      if (moreOptionsLink) {
        const restDesktopSpan = moreOptionsLink.querySelector('[data-rest-desktop]');
        const restMobileSpan = moreOptionsLink.querySelector('[data-rest-mobile]');
        
        if (restDesktopSpan) {
          restDesktopSpan.textContent = restDesktop > 0 ? `+${restDesktop}` : '';
        }
        if (restMobileSpan) {
          restMobileSpan.textContent = restMobile > 0 ? `+${restMobile}` : '';
        }

        // Show/hide the more link based on whether there are hidden items
        const showMore = isMobile ? (restMobile > 0) : (restDesktop > 0);
        moreOptionsLink.style.display = showMore ? '' : 'none';
      }
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.container && this.container.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    getProductJson() {
      let productUrl = `${window.MinimogSettings.routes.root}/products/${this.productHandle}.js`;
      productUrl = productUrl.replace("//", "/");
      return fetch(productUrl).then(function (response) {
        return response.json();
      });
    }

    initOptionSwatches() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.MinimogSettings;

      this.domNodes.optionNodes.forEach((optNode) => {
        const { optionType, optionPosition, value: optionValue } = optNode && optNode.dataset;
        const optionValueLowerCase = optionValue && optionValue.toLowerCase();
        const variantToShowSwatchImage = this.variantData.find((v) => v[`option${optionPosition}`] === optionValue);
        const variantImage =
          variantToShowSwatchImage &&
          variantToShowSwatchImage.featured_image &&
          variantToShowSwatchImage.featured_image.src
            ? getSizedImageUrl(variantToShowSwatchImage.featured_image.src, "60x")
            : null;
        const customImage =
          _imageSwatches.find((i) => i.key === optionValueLowerCase) &&
          _imageSwatches.find((i) => i.key === optionValueLowerCase).value;
        const customColor =
          _colorSwatches.find((c) => c.key === optionValueLowerCase) &&
          _colorSwatches.find((c) => c.key === optionValueLowerCase).value;
        if (variantImage || customImage) optNode.classList.add("has-bg-img");

        switch (optionType) {
          case "default":
            if (customImage || variantImage) {
              optNode.style.backgroundImage = `url(${customImage || variantImage || ""})`;
            }
            break;
          case "image":
            if (variantImage || customImage) {
              optNode.style.backgroundImage = `url(${variantImage || customImage || ""})`;
            }
            break;
          case "color":
            const colorValue = customColor ? customColor : optionValueLowerCase;
            // Suporte para múltiplas cores (separadas por |)
            if (colorValue && colorValue.includes('|')) {
              const colors = colorValue.split('|').map(c => c.trim());
              let gradient = '';
              if (colors.length === 2) {
                gradient = `conic-gradient(${colors[0]} 0deg 180deg, ${colors[1]} 180deg 360deg)`;
              } else if (colors.length === 3) {
                gradient = `conic-gradient(${colors[0]} 0deg 120deg, ${colors[1]} 120deg 240deg, ${colors[2]} 240deg 360deg)`;
              } else if (colors.length >= 4) {
                gradient = `conic-gradient(${colors[0]} 0deg 90deg, ${colors[1]} 90deg 180deg, ${colors[2]} 180deg 270deg, ${colors[3]} 270deg 360deg)`;
              }
              if (gradient) {
                optNode.style.background = gradient;
              }
            } else {
              optNode.style.background = colorValue;
            }
            if (customImage) optNode.style.backgroundImage = `url(${customImage})`;
            break;
          default:
            break;
        }
      });
    }

    toggleOptionNodeActive(optNode, active) {
      if (!optNode) return;
      if (active) {
        const { optionPosition, value: optionValue } = optNode.dataset;
        this.activeOptionNodeByPosition[optionPosition] = optNode;
        // this.updateOptionLabel(optionPosition, optionValue)

        switch (optNode.tagName) {
          case "INPUT":
            optNode.checked = "checked";
            optNode.dataset.selected = "true";
            break;
          case "OPTION":
            optNode.dataset.selected = "true";
            const select = optNode.closest("select");
            if (select) select.value = optNode.value;
            break;
          case "LABEL":
            optNode.dataset.selected = "true";
            break;
          default:
            if (!optNode.classList.contains("m-product-quickview-button")) {
              console.warn("Unable to activate option node", optNode);
            }
            break;
        }

        this.updateSoldOutBadge(this.getVariantsByActiveOptionValue(optionValue));
      } else {
        if (!["default", "image", "color"].includes(optNode.dataset.optionType)) {
          optNode.style.border = "";
        }
        optNode.checked = false;
        delete optNode.dataset.selected;
        const select = optNode.closest("select");
        if (select) select.value = "";
      }
    }

    updateOptionByVariant(variant) {
      this.domNodes.optionNodes.forEach((optNode) => {
  this.toggleOptionNodeActive(optNode, false);
});
this.activeOptionNodeByPosition = {};

      const { optionNodes } = this.domNodes;
      const { options = [] } = variant || {};
      options.forEach((option, index) => {
        const optPosition = index + 1;
        optionNodes.forEach((optNode) => {
          const _optPosition = Number(optNode.dataset.optionPosition);
          const _optValue = optNode.dataset.value;

          if (_optPosition === optPosition && option === _optValue) {
            this.toggleOptionNodeActive(optNode, true);
          }
        });
      });
      this.updatePrice(variant);
    }

    getVariantFromActiveOptions = () => {
      const {
        productData,
        productData: { initialVariant },
        activeOptionNodeByPosition,
      } = this;
      let options;

      const initialVariantOptions = {
        1: initialVariant.option1,
        2: initialVariant.option2,
        3: initialVariant.option3,
      };

      Object.values(activeOptionNodeByPosition).forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        initialVariantOptions[optionPosition] = value;
      });

      options = Object.values(initialVariantOptions);

      options = options.filter(Boolean);
      let variant = getVariantFromOptionArray(productData, options);
      if (!variant && this.hide_unavailable_product_options) {
        options.pop();
        variant = getVariantFromOptionArray(productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(productData, options);
        }
      }
      this.currentVariant = variant;
      return variant;
    };

    handleSelectVariant(e) {
      let { target } = e;
      let newVariant;

      if (target.classList.contains("combined-variant")) {
        const variantId = Number(e.target.value);
        newVariant =
          this.productData && this.productData.variants && this.productData.variants.find((v) => v.id === variantId);
      } else {
        if (target.tagName === "SELECT") {
          target = target.querySelectorAll("option")[target.selectedIndex];
        }
        if (!target.classList.contains("m-product-option--node__label")) {
          target = target.closest(".m-product-option--node__label");
          if (!target) console.error("Unable to find option node!");
        }
        const { optionPosition } = target.dataset;

        const currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];
        this.toggleOptionNodeActive(currActiveOptNode, false);
        this.toggleOptionNodeActive(target, true);
        newVariant = this.getVariantFromActiveOptions();
      }

      const { variantIdNode } = this;
      if (variantIdNode) {
        variantIdNode.setAttribute("value", String(newVariant.id));
        variantIdNode.value = String(newVariant.id);
      }

      this.updateBySelectedVariant(newVariant);
    }

    updateBySelectedVariant(variant) {
      if (variant) {
        this.currentVariant = variant;
        this.changeProductImage(variant);
        this.updatePrice(variant);
      }
    }

    updateProductCardSoldOutBadge(variant) {
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = variant.available ? "none" : "flex";
      }
    }

    updateSoldOutBadge(variants) {
      let soldOut = true;

      for (let i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          soldOut = false;
          break;
        }
      }

      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none";
      }
    }
    getVariantsByActiveOptionValue = (value) => {
      const { productData: { variants } = {} } = this;
      return variants.filter((variant) => variant.options.indexOf(value) !== -1);
    };

    /**
     * Retorna a URL da próxima imagem na ordem de mídia do produto, a partir da imagem
     * principal da variante. Usada para atualizar .m-product-card__hover-image ao trocar de cor.
     */
    getNextHoverImageSrc(variant) {
      const variantSrc = variant && variant.featured_image && variant.featured_image.src;
      const media = this.productData && this.productData.media ? this.productData.media : [];
      if (!variantSrc || !media.length) return "";
      const imageMedia = media.filter((item) => item && item.media_type === "image");
      if (!imageMedia.length) return "";
      const currentIndex = imageMedia.findIndex((item) => {
        const mediaSrc = (item.preview_image && item.preview_image.src) || item.src || "";
        return mediaSrc && variantSrc && (mediaSrc.indexOf(variantSrc) !== -1 || variantSrc.indexOf(mediaSrc) !== -1);
      });
      if (currentIndex < 0) return "";
      const nextMedia = imageMedia[currentIndex + 1];
      if (!nextMedia) return "";
      return (nextMedia.preview_image && nextMedia.preview_image.src) || nextMedia.src || "";
    }

    changeProductImage(variant) {
      const src = variant && variant.featured_image && variant.featured_image.src;
      const { featuredImage, hoverImage } = this;
      const img = featuredImage && featuredImage.querySelector("img");
      const hoverImg = hoverImage && hoverImage.querySelector("img");

      if (img && src) {
        img.src = `${src}&width=533`;
        img.removeAttribute("srcset");
      }

      // Atualiza a imagem de hover com a próxima foto na ordem de mídia da variante selecionada.
      const nextHoverSrc = this.getNextHoverImageSrc(variant);
      if (hoverImg && nextHoverSrc) {
        hoverImg.src = `${nextHoverSrc}&width=533`;
        hoverImg.removeAttribute("srcset");
      }
    }

    updatePrice(variant) {
      if (MinimogSettings.pcard_show_lowest_prices) return;
      const classes = {
        onSale: "m-price--on-sale",
        soldOut: "m-price--sold-out",
      };

      const money_format = window.MinimogSettings.money_format;

      const { priceWrapper, salePrice, unitPrice, compareAtPrice } = this.domNodes;

      const { compare_at_price, price, unit_price_measurement } = variant;
      const onSale = compare_at_price && compare_at_price > price;
      const soldOut = !variant.available;

      if (onSale) {
        priceWrapper && priceWrapper.classList.add(classes.onSale);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.onSale);
      }

      if (soldOut) {
        priceWrapper && priceWrapper.classList.add(classes.soldOut);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.soldOut);
      }

      if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
      if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

      if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(compare_at_price, money_format)));
      } else {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(price, money_format)));
      }

      if (unit_price_measurement && unitPrice && this.currentVariant) {
        unitPrice.classList.remove("f-hidden");
        const unitPriceContent = `<span>${formatMoney(
          this.currentVariant.unit_price,
          money_format
        )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceContent;
      } else {
        unitPrice && unitPrice.classList.add("f-hidden");
      }
    }

    _getBaseUnit = () => {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
            this.currentVariant.unit_price_measurement.reference_unit;
    };
  }

  customElements.define("pcard-swatch", PcardColorSwatch);

  if (!customElements.get("swatch-button")) {
    class PcardVariantButton extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define("swatch-button", PcardVariantButton);

    if (!customElements.get("swatch-dropdown")) {
      class PcardVariantSelect extends PcardVariantButton {
        constructor() {
          super();
        }
      }

      customElements.define("swatch-dropdown", PcardVariantSelect);
    }
    if (!customElements.get("swatch-image")) {
      class PcardVariantImage extends PcardVariantButton {
        constructor() {
          super();
        }
      }

      customElements.define("swatch-image", PcardVariantImage);
    }
    if (!customElements.get("swatch-color")) {
      class PcardVariantColor extends PcardVariantButton {
        constructor() {
          super();
        }
      }
      customElements.define("swatch-color", PcardVariantColor);
    }
  }
}
